<div class="login-container">
	<mat-card class="mat-card-no-padding" [ngClass]="{ 'background-blue': showResetEmailSent }">
		<div class="row-center banner"></div>

		<div class="login-card-content">
			<div class="margin-container">
				@if (!showResetEmailSent) {
					<div>
						<h2 class="row-center title-margin title-font-size" i18n="@@forgotPassword-resetPassword">
							Reset Password
						</h2>
						<div>
							<p class="subtitle" i18n="@@forgotPassword-subtitleTextWithTrademark">
								Please enter the email address registered to your SentriKey® Access account.
							</p>
						</div>
						<mat-form-field appearance="outline" class="mat-form-centered" subscriptSizing="dynamic">
							<mat-label i18n="@@forgot-PasswordEmail">Email</mat-label>
							<input type="email" matInput [formControl]="emailFormControl" required data-automation-id="email-input" />
							@if (emailFormControl.hasError('email') && !emailFormControl.hasError('required')) {
								<mat-error i18n="@@forgot-passwordEmailError" data-automation-id="email-error">
									Please enter a valid email address
								</mat-error>
							}
							@if (emailFormControl.hasError('required')) {
								<mat-error i18n="@@forgot-passwordEmailRequired" data-automation-id="email-error"> </mat-error>
							}
						</mat-form-field>
						<button
							(click)="onBackClicked()"
							data-automation-id="forgot-password-back-button"
							mat-button
							class="secondary-button-no-border button-small"
							style="margin-bottom: 90px"
							i18n="@@forgotPassword-backButton"
						>
							Back
						</button>
						<button
							(click)="sendPasswordResetEmail()"
							data-automation-id="forgot-password-send-button"
							mat-button
							class="primary-button button-small"
							style="margin-bottom: 90px"
							i18n="@@forgot-passwordSendPassword"
						>
							Send
						</button>
						<div>
							<p class="footer-text" i18n="@@forgotPassword-footerTextWithTrademark">
								Having an issue with your email? Contact your company admin or SentriKey® Support for additional help.
							</p>
						</div>
					</div>
				} @else {
					<div>
						<mat-icon class="success-checkmark">check</mat-icon>
						<h2 class="row-center title" i18n="@@forgotPassword-resetPasswordEmailSent">Reset Password Email Sent</h2>
						<p class="font-14" i18n="@@forgotPassword-accountIssueMessage">
							If an account is associated with
							<b> {{ this.emailFormControl.value }} </b>
							click the link in the email you receive to reset your password.
						</p>
						<button
							mat-button
							class="primary-button button-small"
							(click)="onConfirmClicked()"
							data-automation-id="forgot-password-confirm-button"
							i18n="@@forgotPassword-confirmButton"
						>
							Confirm
						</button>
					</div>
				}
			</div>
		</div>

		<div class="column-flex-end">
			<div class="row-flex-center">
				<mat-divider></mat-divider>
				<div class="tos-and-privacy-policy">
					<app-tos-and-privacy-policy></app-tos-and-privacy-policy>
				</div>
			</div>
		</div>
	</mat-card>
</div>
